import { TextField } from "@mui/material"

export const TextAreas = (props) => {
    return (
        <TextField
            style={{ width: '100%' }}
            id="outlined-multiline-static"
            label={props?.label}
            multiline
            rows={props?.rows || 4}
            name={props?.name}
            value={props?.value}
            onChange={props?.onChange}
            placeholder={props?.placeholder}
        />
    )
}